/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div>
    <div v-if="!assignments || !assignments.length">
      You currently have no assignments.
      <br><br><br>
    </div>
    <div v-else>
      <div
        id="assignmentCards"
        :key="assignmentCardKey"
      >
        <div
          v-for="group in assignmentsByGroup"
          class="assignment-card-group row"
        >
          <div class="group-assignments col-md-12">
            <div class="row">
              <div class="col-sm-4">
                <h2>
                  {{ group.groupName }}
                </h2>
              </div>
              <div
                class="col-sm-4 assignments-toggler"
              >
                <span
                  :class="speakerAssFilterForGroup(group.groupId) == 'recent' ? 'active' : 'hoverLink'"
                  @click.prevent="loadFilter(group.groupId, 'recent')"
                >
                  Recent
                </span>
                |
                <span
                  :class="speakerAssFilterForGroup(group.groupId) == 'completed' ? 'active' : 'hoverLink'"
                  @click.prevent="loadFilter(group.groupId, 'completed')"
                >
                  Completed
                </span>
                |
                <span
                  :class="speakerAssFilterForGroup(group.groupId) == 'active' ? 'active' : 'hoverLink'"
                  @click.prevent="loadFilter(group.groupId, 'active')"
                >
                  Active
                </span>
                |
                <span
                  :class="speakerAssFilterForGroup(group.groupId) == 'all' ? 'active' : 'hoverLink'"
                  @click.prevent="loadFilter(group.groupId, 'all')"
                >
                  All
                </span>
              </div>
              <div
                id="stats"
                class="hidden-xs col-sm-4"
              >
                <!-- TODO: Add Stats Here? -->
              </div>
            </div>
          </div>

          <!-- Assignment Card -->
          <div
            v-if="!group.assignments || !group.assignments.length"
          >
            <h4 style="padding-left: 20px;">
              No assignments.
            </h4>
          </div>
          <div
            v-for="assignment in sortAssignments(group.assignments)"
            :ref="'assignment-' + assignment.assignmentId"
            class="col-xs-6 col-sm-4"
            :class="getClass(assignment)"
            style="padding: 0px;"
          >
            <strong>
              <router-link
                :to="{ name: 'assignment-details',
                       params: {assignmentId: assignment.assignmentId } }"
              >
                <span class="assignmentName">
                  {{ assignment.name | truncate25 }}
                </span>
              </router-link>
              <div class="assignment-status">
                Status: {{ getStatus(assignment) | capitalize }}
              </div>
            </strong>

            <div
              class="assignment-description"

              @click.prevent="$router.push({ name: 'assignment-details', params: {assignmentId: assignment.assignmentId }})"
            >
              {{ assignment.description }}
            </div>
            <br>
            <div
              class="recordingLinkContainer"
            >
              <router-link
                v-if="algorithmOnOrg(assignment)"
                :to="{ name: 'record',
                       query: {assignmentId: assignment.assignmentId } }"
              >
                <svg class="svgicon icon-record">
                  <use xlink:href="/static/svg-symbols.svg#icon-record" />
                </svg><span>{{ getRecordingText(assignment) }}</span>
              </router-link>
              <span v-else>
                &nbsp;
              </span>
              <span class="assignmentRecordingType">
                {{ getRecordingType(assignment) }}
              </span>
            </div>
            <div
              class="assignmentStats rTable"
            >
              <div class="rTableRow">
                <div
                  class="rTableCell rTableCellBorder"
                  @click.prevent="myRecordingsClicked(assignment)"
                >
                  MY RECORDINGS<br>
                  <span class="stat">
                    {{ getStat(assignment, 'myRecordings') }}
                  </span>
                  <svg class="icon-microphone">
                    <use xlink:href="/static/svg-symbols.svg#icon-microphone" />
                  </svg>
                </div>
                <div
                  :class="group.speakerPrivacyLevel !== 4 ? 'rTableCell rTableCellBorder' : 'rTableCell'"
                  @click.prevent="$router.push({ name: 'assignment-details', params: {assignmentId: assignment.assignmentId }, query: {collapsed: 1}})"
                >
                  COMMENTS<br>
                  <span class="stat">
                    {{ getStat(assignment, 'comments') }}
                  </span>
                  <svg class="icon-comment">
                    <use xlink:href="/static/svg-symbols.svg#icon-comment" />
                  </svg>
                </div>
                <div
                  v-if="group.speakerPrivacyLevel !== 4"
                  class="rTableCell"
                  @click.prevent="$router.push({ name: 'assignment-details', params: {assignmentId: assignment.assignmentId }, query: {collapsed: 1}})"
                >
                  PEER RECORDINGS<br>
                  <span class="stat">
                    {{ getStat(assignment, 'peerRecordings') }}
                  </span>
                  <svg class="icon-users">
                    <use xlink:href="/static/svg-symbols.svg#icon-users" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  @import '../../less/bootstrap-vars.less';
  @import '~bootstrap/less/mixins/buttons.less';
  .group-assignments {
    margin-top: 20px;
    h2 {
      font-size: 24px;
      line-height: 32.68px;
    }
  }
  .rTable { display: table; width: 100%}
  .rTableRow { display: table-row; }
  .rTableCell { display: table-cell; width: 24%; text-align: center; font-size: 5pt; padding-top: 5px; }
  .rTableCellBorder { border-right: 1px solid #ccc; }
  hr {
    margin: 5px;
  }
  .assignmentStats {
    padding-top: 2px;
    color: #333;
    font-size: 11px;
    .stat {
      color: #DE2800;
    }
  }
  .assignmentName {
    color: #333;
    font-size: 14pt;
  }
  .assignment-status {
    font-size: 9px;
    font-weight: 400;
  }
  .assignment-description {
    font-size: 14px;
    font-weight: 400;
    height: 42px;
    padding-bottom: 0px;
    overflow: hidden;
    border-top: 1px solid #ccc;
  }
  .recordingLinkContainer {
    border-bottom: 1px solid #ccc;
    a {
      color: #333;
    }
    span {
      position: relative;
      bottom: 6px;
      left: 5px;
    }
  }
  .assignmentRecordingType {
    font-size: 10px;
    color: #333;
    float: right;
    position: relative;
    top: 7px;
    margin-right: 8px;
  }
  .icon-file, .icon-comment, .icon-microphone, .icon-users {
    width: 14px;
    height: 14px;
    position: relative;
    top: 3px;
  }
  .svgicon {
    display: inline-block;
    stroke-width: 0;
    stroke: currentColor;
    fill: currentColor;
  }
  .icon-record {
    width: 23px; height: 23px;
  }
  .assignmentIcon {
    position: relative;
    top: 2px;
  }
  .icon-pencil {
    width: 16px; height: 16px;
  }
  .assignment {
    height: 182px;
    width: 355px;
    margin: 10px;
    padding: 10px !important;
    cursor: pointer;
    background-color: #f2f2f2;
    border-radius: 8px;
  }
  /*
  .pending {
    background-color: #ECF3FF;
  }
  .completed {
    background-color: #a4c9cb;
    .assignmentStats {
      color: black;
    }
  }
  */
  .assignmentActions {
    height: 40px;
    padding-top: 20px;
    padding-bottom: 10px;
    overflow: hidden;
    border-top: 1px solid #ccc;
  }
  .assignment-card-group {
    border-bottom: 1px solid #ccc;
    padding-bottom: 15px;
    h2 {
      margin-top: 0px;
    }
  }
  .assignments-toggler {
    /* if on same row as group name, needs to be pushed down a bit */
    @media (min-width: 768px) {
      position: relative;
      top: 15px;
    }
    cursor: pointer;
  }
  .assignments-toggler span {
    color: @brand-primary;
    cursor: pointer;
  }
  .assignments-toggler span.active {
    color: #333;
    cursor: default;
  }
</style>

<script>
import TableMethods from '../specials/TableMethods';

export default {
  mixins: [TableMethods],
  props: [ 'assignments', 'me', 'groups' ],
  data() {
    return {
      speakerAssignmentFilters: {}, // Only access this via speakerAssFilterForGroup() method
      assignmentCardKey: 1,
    };
  },
  computed: {
    preferences() {
      return this.$store.getters.preferences;
    },
    assignmentsByGroup: {
      cache: false,
      get() {
        const filterFuncs = {
          completed: (a) => {
            return a.completionStatus.status == 'completed';
          },
          active: (a) => {
            return a.archived !== true && a.completionStatus.status != 'completed';
          },
          all: () => {
            return true;
          },
          recent: (a) => {
            const assDate = new Date(a.myUserTarget.createdDate).getTime() / 1000;
            let backWhen = new Date().getTime() / 1000;
            backWhen = backWhen - (28 * (60 * 60 * 24));
            const isRecentlyCompleted = (a.completionStatus.status == 'completed' && assDate > backWhen);
            return (a.archived !== true &&
              (a.completionStatus.status != 'completed' || isRecentlyCompleted)) ||
              (a.archived === true && (a.completionStatus.status === 'in progress' || isRecentlyCompleted));
          },
        };

        const abg = [];
        this.groups.forEach((group) => {
          const filterName = this.speakerAssFilterForGroup(group.groupId);
          const filterMatches = filterFuncs[filterName] || filterFuncs.all;
          const groupAssignment = {
            groupName: group.name,
            groupId: group.groupId,
            speakerPrivacyLevel: group.speakerPrivacyLevel,
            assignments: [],
          };
          this.assignments.forEach((a) => {
            if (a.groupId == group.groupId && filterMatches(a)) {
              groupAssignment.assignments.push(a);
            }
          });
          abg.push(groupAssignment);
        });
        return abg;
      }
    }
  },
  created() {
    if (this.preferences && this.preferences.speakerAssignmentFilters) {
      this.speakerAssignmentFilters = this.preferences.speakerAssignmentFilters;
    }
  },
  methods: {
    algorithmOnOrg(assignment) {
      if (!assignment.criteria || !assignment.criteria.algorithm) {
        return true;
      }
      let supported = false;
      const assignmentAlgorithmFeatureName = assignment.criteria.algorithm.split('-')[1];
      const algorithms = this.$store.getters.org.algorithmConfig.algorithms;
      algorithms.forEach((algo) => {
        const orgAlgorithmFeatureName = algo.name.split('-')[1];
        if (orgAlgorithmFeatureName === assignmentAlgorithmFeatureName) {
          supported = true;
        }
      });
      return supported;
    },
    getRecordingText(assignment) {
      if (!assignment.criteria || !assignment.criteria.algorithm) return 'Record';
      return assignment.criteria.algorithm.indexOf('conversational') === -1 ?
        'Record (Single Speaker)' : 'Record (Multi-Speaker)';
    },
    myRecordingsClicked(assignment) {
      // Update the preferences so the current user is expanded
      const tableRowIndices = this.preferences.tableRowIndices || {};
      tableRowIndices['assPreview.user1'] = {
        [this.$store.getters.user.userId]: 1,
      };

      // Persist state
      return this.$store.dispatch(
        'updatePreferences',
        Object.assign(this.preferences, {tableRowIndices})
      ).then(
        () => {
          return this.$router.push({name: 'assignment-details', params: {assignmentId: assignment.assignmentId}, query: {collapsed: 1, myRecordings: 1}});
        }
      );
    },
    speakerAssFilterForGroup(groupId) {
      if (this.speakerAssignmentFilters[groupId]) {
        return this.speakerAssignmentFilters[groupId];
      }

      // Add the default value for this group
      this.setSpeakerAssFilterForGroup(groupId, 'recent');
      return 'recent';
    },
    setSpeakerAssFilterForGroup(groupId, filterVal) {
      this.speakerAssignmentFilters[groupId] = filterVal;
      this.$store.dispatch(
        'updatePreferences',
        Object.assign(this.preferences, {speakerAssignmentFilters: this.speakerAssignmentFilters})
      );
    },
    getRecordingType(assignment) {
      if (!assignment.criteria || !assignment.criteria.algorithm) return '';
      return assignment.criteria.algorithm.indexOf('conversational') === -1 ?
        'SINGLE SPEAKER' : 'MULTI-SPEAKER';
    },
    loadFilter(groupId, filterVal) {
      this.setSpeakerAssFilterForGroup(groupId, filterVal);
      this.assignmentCardKey += 1; // Force re-render
    },
    getClass(assignment) {
      if (assignment.archived || assignment.deleted || assignment.completionStatus.status == 'completed') {
        return 'assignment completed';
      }
      return 'assignment pending';
    },
    getStatus(assignment) {
      if (assignment.archived || assignment.deleted) {
        return 'Completed (Disabled by Your Coach)';
      }
      return assignment.completionStatus.status;
    },
    getStat(assignment, statName) {
      let stat = 0;
      switch (statName) {
      case 'comments':
        assignment.members.forEach((u) => {
          u.recordings.forEach((r) => {
            if (r.userId == this.me.userId && r.feedback) {
              stat += parseInt(r.feedbackCount, 10);
            }
          });
        });
        break;
      case 'myRecordings':
      case 'peerRecordings':
        assignment.members.forEach((u) => {
          u.recordings.forEach((r) => {
            if (statName == 'myRecordings' && r.userId == this.me.userId) {
              stat += 1;
            } else if (statName == 'peerRecordings' && r.userId != this.me.userId && r.feedbackRequested) {
              stat += 1;
            }
          });
        });
        if (assignment.criteria.minRecordings && assignment.criteria.minRecordingsCount && statName == 'myRecordings') {
          stat += ` / ${assignment.criteria.minRecordingsCount}`;
        }
        break;
      }
      return stat;
    },
    getCompletionStatus(assignment) {
      const status = _.find(assignment.userTargets, (ut) => ut.userId === this.me.userId);
      return status.completionStatus.status;
    }
  }
};
</script>
